import { ParsedActionError } from "./types/types"

// environmental variables
export const CAPTCHA_SITE_KEY = process.env.PUBLIC_CAPTCHA_SITE_KEY as string
export const MOCK_ALL_APIS = false
export const CORE_API_ENDPOINT = process.env.PUBLIC_CORE_API_ENDPOINT as string
export const GA_MEASUREMENT_ID = process.env.PUBLIC_GA_MEASUREMENT_ID as string
export const ASSETS_BUCKET = process.env.PUBLIC_ASSETS_BUCKET as string
export const DEMO_SIGN_UP_ENABLED = process.env.PUBLIC_DEMO_SIGN_UP_ENABLED === "true"
export const DEMO_LABS_ENABLED = process.env.PUBLIC_DEMO_LABS_ENABLED === "true"
export const SOCKET_PROXY_ENDPOINT = process.env.PUBLIC_SOCKET_PROXY_ENDPOINT as string
export const BASE_URL = process.env.PUBLIC_BASE_URL as string

export const GROOVE_API_KEY = process.env.GROOVE_API_KEY as string

// testing
export const MOCK_API_TIMEOUT = 1000

// labs
export const MIN_WINDOW_LAB_WIDTH = 850
export const LAB_LANGUAGES = ["python_3", "python_2", "c", "asm"] as const

export const LAB_LANGUAGE_LABELS = {
  python_3: "Python 3",
  python_2: "Python 2",
  c: "C",
  asm: "ASM",
} as const

export const LAB_FILE_EXTENSIONS = {
  python_3: "py",
  python_2: "py",
  c: "c",
  asm: "asm",
} as const

// knowledge
export const GROOVE_KNOWLEDGE_BASE_URL = `https://api.groovehq.com/v1/kb/9010029304`

// support email
export const SUPPORT_EMAIL = "support@sans.org"
export const SUPPORT_EMAIL_MAIL_TO = `mailto:${SUPPORT_EMAIL}`

// support defaults
export const SUPPORT_CONTACT_LINK = {
  label: "Contact us",
  href: SUPPORT_EMAIL_MAIL_TO,
}
export const FALLBACK_ERROR_MESSAGE: ParsedActionError = {
  title: "Something went wrong",
  message: "Please try again, or contact us if the problem persists.",
  links: [SUPPORT_CONTACT_LINK],
}
export const INVALID_RECAPTCHA_MESSAGE: ParsedActionError = {
  title: `Invalid reCAPTCHA response`,
  message: `We were unable to validate your request. Please refresh your browser and try again`,
  links: [{ label: `Contact us`, href: SUPPORT_EMAIL_MAIL_TO }],
}
export const INVALID_INPUT_MESSAGE: ParsedActionError = {
  title: "Invalid input",
  message: "Some of the information provided is invalid. Please check your details and try again.",
  links: [{ label: `Contact us`, href: SUPPORT_EMAIL_MAIL_TO }],
}

export const AUTOCOMPLETE_TIMEOUT = 1000 * 10 // 10 seconds

// query keys
export const COURSE_PROGRESS_CACHE_KEY = "courseProgress"
